/*************************************************************************/
/***************************** FOUNDATION INIT ***************************/
/*************************************************************************/

	$(document).foundation();

/*************************************************************************/
/******************************* MAIN MENU *******************************/
/*************************************************************************/

	$(document).bind('_js_ready', function() {
		/*$("#popin_menu").on("closed.zf.reveal",function(){
			// Change burger state to inactive
			$(".hamburger").removeClass("is-active");
		});*/

		// MENU OVERLAP / ou / PUSH MEDIUM + SMALL
		$('#offCanvasLeft').on('opened.zf.offcanvas',function(){
			$('#smart_menu .menu').on('open.zf.drilldown',function(){
				$(".is-drilldown-submenu-parent[aria-expanded='true']").parent("ul").scrollTop(0).addClass('overflow');
			});
		});

		$('.js-drilldown-back a').on('click',function(){
			$(this).parent("li").parent("ul").parent("li").parent("ul").scrollTop(0).removeClass('overflow');
		});

		$('#offCanvasLeft').on('closed.zf.offcanvas',function(){
			$(".hamburger").removeClass("is-active");
			$(".is-drilldown-submenu-parent").attr('aria-expanded', 'false').parent("ul").scrollTop(0).removeClass('overflow');
			$('#offCanvasLeft ul').scrollTop(0).removeClass('overflow');
		});


		// Version popin : bouton au N2 pour ouvrir N3
	    /*$("#menu_principal .level2.has-submenu-toggle a span").each(function(index){
	        let initial_intitule = $(this).parent("a").parent(".level2.has-submenu-toggle").children('button').children("span").text();
	        let new_intitule = initial_intitule + " " + $(this).text();
	        // Modif title + span
	        $(this).parent("a").attr('tabindex', '-1').parent(".level2.has-submenu-toggle").children('button').attr("title", new_intitule).children("span").text(new_intitule);
	    });*/

	    // Version horizontale
	    $("#menu_principal > ul > li").removeAttr("aria-expanded");
		$("#menu_principal > ul > li > a").each(function(index){
			let initial_intitule = $(this).parent("li.has-submenu-toggle").children('button').text();
			let new_intitule = initial_intitule + " " + $(this).text();
			// Modif title + span
			$(this).parent("li.has-submenu-toggle").children('button').attr("title", new_intitule).children("span").text(new_intitule);
			$(this).parent("li.has-submenu-toggle").children('a').attr('tabindex', '-1');
		});

		let menu_principal = $('#menu_principal');

		menu_principal.on('up.zf.accordionMenu down.zf.accordionMenu',function(){
			$("#menu_principal > ul > li").removeAttr("aria-expanded");
			/*#overlay_menu,*/ $("#btn_close_horizontal_menu").addClass("is-hidden");
		});
		menu_principal.on('down.zf.accordionMenu',function(){
			$("#header").addClass("horizontal_menu_is_open");
			$("#menu_principal > ul > li > ul[aria-hidden='false']").parent("li").addClass("aria-expanded");
			/*#overlay_menu,*/ $("#btn_close_horizontal_menu").removeClass("is-hidden");
		});

		menu_principal.on('up.zf.accordionMenu',function(){
			$("#menu_principal > ul > li > ul[aria-hidden='false']").parent("li").removeClass("aria-expanded");
			$("#menu_principal li ul.sous_menu.is-active").removeClass("is-active");
		});

		/*#overlay_menu,*/ $("#btn_close_horizontal_menu").on("click", function(){
			$("#header").removeClass("horizontal_menu_is_open");
			$("#menu_principal > ul > li").removeAttr("aria-expanded");
			$("#menu_principal > ul > li > button[aria-expanded='true']").attr("aria-expanded", "false");
			$("#menu_principal > ul > li > ul[aria-hidden='false']").parent("li").removeClass("aria-expanded");
			$("#menu_principal li ul.sous_menu.is-active").removeClass("is-active");
			$("#btn_close_horizontal_menu").addClass("is-hidden");
		});

	});


	// GESTION OUVERTURE POPIN MENU AVEC LE SOUS MENU DU PARENT SUR LEQUEL ON A CLIQUE
	/*$(document).bind('_js_ready', function() {
		$("#acces_rapide_navigation li").each(function(index){
			$(this).addClass('rubrique' + index );
		});
		$("#menu_principal_home > ul > li, #menu_principal > ul > li").each(function(index){
			$(this).addClass('rubrique' + index );
		});
		$("#acces_rapide_navigation .rubrique0 a").on("click",function(){
			$("#popin_menu.home").addClass("rubrique0_is_active").removeClass("rubrique1_is_active rubrique2_is_active");
			$("#popin_menu.home.rubrique0_is_active").on("open.zf.reveal",function(){
				$("#menu_principal_home li.rubrique0").addClass("is_open").removeClass("hide");
				$("#menu_principal_home li.rubrique1, #menu_principal_home li.rubrique2").removeClass("is_open").addClass("hide");
			});
		});
		$("#acces_rapide_navigation .rubrique1 a").on("click",function(){
			$("#popin_menu.home").addClass("rubrique1_is_active").removeClass("rubrique0_is_active rubrique2_is_active");
			$("#popin_menu.home.rubrique1_is_active").on("open.zf.reveal",function(){
				$("#menu_principal_home li.rubrique1").addClass("is_open").removeClass("hide");
				$("#menu_principal_home li.rubrique0, #menu_principal_home li.rubrique2").removeClass("is_open").addClass("hide");
			});
		});
		$("#acces_rapide_navigation .rubrique2 a").on("click",function(){
			$("#popin_menu.home").addClass("rubrique2_is_active").removeClass("rubrique1_is_active rubrique0_is_active");
			$("#popin_menu.home.rubrique2_is_active").on("open.zf.reveal",function(){
				$("#menu_principal_home li.rubrique2").addClass("is_open").removeClass("hide");
				$("#menu_principal_home li.rubrique0, #menu_principal_home li.rubrique1").removeClass("is_open").addClass("hide");
			});
		});
	});


	 */

/*************************************************************************/
/******************************* AUTOCOMPLETE ****************************/
/*************************************************************************/

	deleteAutocomplete = function() {
		if(typeof $( "#main_search" ).autocomplete( "instance" ) !== 'undefined') {
			$( "#main_search" ).autocomplete( "destroy" );
		}
		$("#suggestions-list").removeClass('hide');
	}

	bindAutocomplete = function(){
		var autocompleteResultClicked = false;
		$("#main_search").autocomplete({
			appendTo: "#autocomplete_results",
			create: function() {
				$(this).data('ui-autocomplete')._renderItem  = function (ul, item) {
					return $( "<li>" )
						.append(
							$("<a>")
								.removeAttr("style")
								.removeAttr("class")
								.addClass("grid-x grid-margin-x align-justify align-middle")
								.attr("href", item.value)
								.attr("title", item.label)
								.attr("data-counter-url-search", item.counter_url_search)
								.append($("<span>").addClass("resultat cell auto").append($("<span>").append(item.label)))
								.append($("<span>").addClass("categories cell shrink").append(item.type))
						)
						.appendTo( ul );
				};
				$(this).data('ui-autocomplete')._renderMenu  = function (ul, items) {
					$(ul).removeAttr("class").removeAttr("style");
					var that = this;
					$.each( items, function( index, item ) {
						that._renderItemData( ul, item );
					});
				}
			},
			select: function (event, ui) {
				let url = ui.item.value
				window.location = url;
				return false;
			},
			focus: function (event, ui) {
				return false;
			},
			response: function( event, ui ) {},
			source: function (request, response) {
				$.ajax({
					dataType: "json",
					url: $('#tx_indexedsearch').attr('action'),
					data: {
						q: request.term,
						type: 889,
						tx_cimelastic_search: {action: 'autocomplete', controller: 'Search'},
						elementId: $('#tx_indexedsearch').attr('data-element-id')
					},
					success: function (data) {
						$('#autocomplete_results li').remove();
						// Hide all by default
						$('#suggest_title').addClass('hide');
						$("#suggestions-list").addClass('hide');
						$('#suggestions_no_results').addClass('hide');
						$("#show_more_results").addClass('hide');
						$("#suggestions_no_results_corrected").addClass('hide');
						$("#suggestions_results_but_suggest").addClass('hide');

						// Absolutely no results
						if (data.length === 0 && typeof data.correctedWord === 'undefined') {
							$('#suggestions_no_results').removeClass('hide');
						}
						// No results with searched word but corrected
						else if(typeof data.correctedWord !== 'undefined') {
							$('#result_title').removeClass('hide');

							$("#searchedWord").html(request.term);
							$("#correctedWord").html(data.correctedWord);

							$("#suggestions_no_results_corrected").removeClass('hide');


							$("#show_more_results a").attr("href", $("#tx_indexedsearch").attr('action') + "?q=" + data.correctedWord);
							$("#show_more_results").removeClass('hide');
						}
						// Got results, but we have suggested word
						else if(typeof data.suggestedWord !== 'undefined') {
							$('#result_title').removeClass('hide');

							$("#suggestedWord").html($('<a>').attr("href", $("#tx_indexedsearch").attr('action') + "?q=" + data.suggestedWord).text(data.suggestedWord));
							$("#suggestions_results_but_suggest").removeClass('hide');

							$("#show_more_results a").attr("href", $("#tx_indexedsearch").attr('action') + "?q=" + $("#main_search").val());
							$("#show_more_results").removeClass('hide');
						}
						// Results
						else {
							$('#result_title').removeClass('hide');

							$("#show_more_results").removeClass('hide');
							$("#show_more_results a").attr("href", $("#tx_indexedsearch").attr('action') + "?q=" + $("#main_search").val());

						}

						response(data.data);
					}
				});
			},
			open: function(){
				$("#suggestions").removeClass('hide');
				$("#suggestions-list").addClass('hide');
				//$("#suggest_title").text("Résultats");
				$(this).autocomplete('widget').removeAttr("style");
			},
			close: function() {
				if($("#main_search").val().length > 1) {
					$("#autocomplete_results ul").show();
					return false;
				}
				if(autocompleteResultClicked) {
					$("#suggestions").addClass('hide');
					return false;
				}
				//$("#suggest_title").text("Les pages les plus consultées");
				$("#show_more_results").addClass('hide');
				$('#suggestions_results_but_suggest').addClass('hide');
				$('#result_title').addClass('hide');
				$('#suggest_title').removeClass('hide');
				$('#suggestions_no_results').addClass('hide');
				$("#suggestions-list").removeClass('hide');
			},
			minLength: 2,
		});
	}
	bindListAutoComplete = function(){
		$.widget( "custom.combobox", {
			_create: function() {
				this.wrapper = $( "<span>" )
					.addClass( "custom-combobox" )
					.insertAfter( this.element );

				this.element.hide();
				this._createAutocomplete();
				this._createShowAllButton();
				this.input.attr("placeholder", this.element.attr('title'));
				this.input.focus().blur();
			},

			_createAutocomplete: function() {
				let selected = this.element.children( ":selected" ),
					value = selected.val() ? selected.text() : "";

				// fix accessibilité : pour que champ visible input.custom-combobox-input soit lié au label
				let inputID = this.element.attr('id');
				this.element.removeAttr('id', '');

				this.input = $( "<input>" )
					.appendTo( this.wrapper )
					.val( value )
					.removeAttr( "title", "" )
					.attr( "id", inputID ) // on assigne l'id au champ
					.addClass( "custom-combobox-input ui-widget ui-widget-content ui-state-default ui-corner-left" )
					.autocomplete({
						delay: 0,
						minLength: 0,
						source: $.proxy( this, "_source" ),
						messages : {
					      noResults : 'Aucun résultat correspondant',
					      results : function(count) {
					        return count + (count > 1 ? ' résultats sont disponibles' : ' résultat disponible') + ', utilisez les flèches haut et bas pour naviguer';
					      }
					    }
					})
					.tooltip({
						classes: {
							"ui-tooltip": "ui-state-highlight"
						}
					});
					// .on('focus', function() { console.log('test autocomplete'); });

				this._on( this.input, {
					autocompleteselect: function( event, ui ) {
						ui.item.option.selected = true;
						this._trigger( "select", event, {
							item: ui.item.option
						});
					},

					autocompletechange: "_removeIfInvalid"
				});
			},

			_createShowAllButton: function() {
				let input = this.input,
					wasOpen = false;

				$( "<a>" )
					.attr( "tabIndex", -1 )
					.attr( "title", "Afficher tous les éléments" )
					.tooltip()
					.appendTo( this.wrapper )
					.button({
						icons: {
							primary: "ui-icon-triangle-1-s"
						},
						text: false
					})
					.removeClass( "ui-corner-all" )
					.addClass( "custom-combobox-toggle ui-corner-right" )
					.on( "mousedown", function() {
						wasOpen = input.autocomplete( "widget" ).is( ":visible" );
					})
					.on( "click", function() {
						input.trigger( "focus" );

						// Close if already visible
						if ( wasOpen ) {
							return;
						}

						// Pass empty string as value to search for, displaying all results
						input.autocomplete( "search", "" );
					});
			},

			_source: function( request, response ) {
				let matcher = new RegExp( $.ui.autocomplete.escapeRegex(request.term), "i" );
				response( this.element.children( "option" ).map(function() {
					let text = $( this ).text();
					if ( this.value && ( !request.term || matcher.test(text) ) )
						return {
							label: text,
							value: text,
							option: this
						};
				}) );
			},

			_removeIfInvalid: function( event, ui ) {

				// Selected an item, nothing to do
				if ( ui.item ) {
					return;
				}

				// Search for a match (case-insensitive)
				let value = this.input.val(),
					valueLowerCase = value.toLowerCase(),
					valid = false;
				this.element.children( "option" ).each(function() {
					if ( $( this ).text().toLowerCase() === valueLowerCase ) {
						this.selected = valid = true;
						return false;
					}
				});

				// Found a match, nothing to do
				if ( valid ) {
					return;
				}

				// Remove invalid value
				this.input
					.val( "" )
					.attr( "title", value + " Aucune valeur correspondante" )
					.tooltip( "open" );
				this.element.val( "" );
				this._delay(function() {
					this.input.tooltip( "close" ).removeAttr( "title");
				}, 2500 );
				if (this.input.autocomplete( "instance" ) !== undefined)
					this.input.autocomplete( "instance" ).term = "";
			},

			_destroy: function() {
				this.wrapper.remove();
				this.element.show();
			}
		});
	}

    $(document).bind('_js_ready', function() {
        bindListAutoComplete();
        $( "#combobox" ).combobox();
		bindAutocomplete()
    });


/*************************************************************************/
/**************************** ANIMATIONS BLOCS ***************************/
/*************************************************************************/

	// POPIN EN 1 CLIC
		/*let interval;
	    function timerFunction(id) {
	        $(function () {
	            let el = $(".acces_rapides_item");
	            let index = 0;
	            interval = setInterval(function () {
	                if  (  (index < el.length) ) {
	                    el.eq(index++).addClass("mui-enter-active");
	                } else {
	                  clearInterval(interval);
	                }
	            }, 200);
	        });
	    }
	    function playTimer(){ timerFunction();}
	    function stopTimer(){ clearInterval(interval);}

	    let the_element = $("#popin_acces_rapides");

	  	the_element.on("open.zf.reveal",function(){
	        $(this).addClass("open");
	        playTimer();
	        // Fade appearing title
	        $("#popin_acces_rapides #acces_rapides").addClass("mui-enter-active");
	    });

		the_element.on("closed.zf.reveal",function(){
			$(this).removeClass("open");
			stopTimer();
			$("#popin_acces_rapides .acces_rapides_item, #popin_acces_rapides #acces_rapides").removeClass("mui-enter-active");
		});*/

	// LISTE : APPARITION DES ITEMS AU CHARGEMENT

	// Add Class to popin item to display them one after the other
	let intervalList;
	function timerFunctionListSearch(id) {
		let el = $(".list_item:not(.mui-enter-active), .appear");
		let index = 0;
		let interval = setInterval(function () {
			if ( (index < el.length) ) {
				el.eq(index++).addClass("mui-enter-active");
			} else {
			clearInterval(interval);
			}
		}, 200);
	}
	function playTimerListSearch(){ timerFunctionListSearch();}
	function stopTimerListSearch(){ clearInterval(intervalList);}

	$(document).bind('_js_ready', function() {
		playTimerListSearch();
	});


/*************************************************************************/
/********************** GLOBAL PADDING FOOTER/HEADER *********************/
/*************************************************************************/

	$(document).bind('_js_ready', function() {

		// Gestion du padding necessaire au footer
		let footer_H = $('#footer').outerHeight(),
			windows_H = $(window).height(),
			main = $('#main'),
			home_main = $('#home #main');

		function padding_for_footer() {
			if (Foundation.MediaQuery.atLeast('large')) {
				main.css({"padding-bottom" : footer_H});
				home_main.css({"min-height" : windows_H});
			}  else {
				main.css({"padding-bottom" : "inherit"});
				home_main.css({"min-height" : "inherit"});
			}
		} padding_for_footer();

		// Gestion du padding necessaire au header en responsive
		function padding_for_header() {
			let rwd_header = $("#data-sticky-header").outerHeight(),
				offcanvas_content = $(".off-canvas-content"),
				offcanvas_left = $('#offCanvasLeft');

			if (Foundation.MediaQuery.current == "small" || Foundation.MediaQuery.current == "medium") {
				offcanvas_content.css({"padding-bottom" : rwd_header});
				offcanvas_left.css({"height" : ($(window).height() - rwd_header) })
			} else {
				offcanvas_content.css({"padding-bottom" : 'initial'});
				offcanvas_left.css({"height" : 'auto' })
			}
		} padding_for_header();


		$(window).on('resize', function() {
			padding_for_footer();
			padding_for_header();
		});
	});


/*************************************************************************/
/******************************* DATE PICKER *****************************/
/*************************************************************************/

	$(document).bind('_js_ready', function() {
		$(function(){
			window.prettyPrint && prettyPrint();
			$('.dp1').fdatepicker({
				format: 'dd/mm/yyyy',
				language: 'fr',
				disableDblClickSelection: true
			});
		});

		function datepickerPosition() {
			let html_offset = Math.abs(parseInt($("html").css('top')));
			let dp1_offset = $(".dp1").offset().top;
			let dp1_height = $(".dp1").innerHeight();
			let top = html_offset + dp1_offset + dp1_height;

			if ($(".dp1").offset().top + $(".datepicker:visible").innerHeight() > $('.reveal-overlay').innerHeight()) {
				let top = html_offset + dp1_offset - $(".datepicker:visible").innerHeight();
			} else {
				let top = html_offset + dp1_offset + dp1_height;
			}
			$('.datepicker:visible').css({"top": top });
		}

		if ($(".dp1").length > 0) {
			$(".dp1").on('show',function(){ datepickerPosition(); });
			$(window).on('resize',function(){ datepickerPosition(); });
			$($("#popin_filters").parent(".reveal-overlay")).on('scroll',function(){ datepickerPosition(); });
		}
	});

/*************************************************************************/
/******************************* FOCUS LIST ITEM *************************/
/*************************************************************************/

	function focusing() {

      $(".list_item a").on("focusin", function() {
          $(this).parents(".list_item").addClass("focusing");
      });
      $(".list_item:not(.poi) a").on("focusout", function() {
          $(this).parents(".list_item").removeClass("focusing");
      });

    }
    $(document).bind('_js_ready', function() {
		focusing();
    });

/*************************************************************************/
/****************** POPIN FILTRES RECHERCHE GENERALE *********************/
/*************************************************************************/

	// SYSTEME ASPIR FILTRES
	/*
	$(document).bind('_js_ready', function() {
		$(".recherche_gen #filters").on("open.zf.reveal",function(){
			$("#main").addClass("filters_opened");
			$("#content_page").addClass("filters_opened");
			let getAspireForm = $("#aspire_keyword");
			let getAspireSubmit = $("#aspire_submit");
			$("#reveal_aspire_keyword").append(getAspireForm);
			$("#reveal_aspire_submit").append(getAspireSubmit);
		});

		$(".recherche_gen #filters").on("closed.zf.reveal",function(){
			$("#main").removeClass("filters_opened");
			$("#content_page").removeClass("filters_opened");
			let getAspireForm = $("#aspire_keyword");
			let getAspireSubmit = $("#aspire_submit");
			$("#aspire_keyword_wrap").prepend(getAspireForm);
			$("#aspire_submit_wrap").prepend(getAspireSubmit);
		});
	});
	*/


/*************************************************************************/
/**************************** SKIN FORMULAIRES ***************************/
/*************************************************************************/

	$(document).bind('_js_ready', function() {
		// Doc http://icheck.fronteed.com/
		$('.ligne_form.checkbox input, .ligne_form.radio input, .powermail_field .checkbox input, .powermail_field .radio input').iCheck({
			checkboxClass: 'icheckbox icheckbox_minimal',
			radioClass: 'iradio iradio_minimal'
		});
	});


/*************************************************************************/
/****************************** ACTU POPIN FIX ***************************/
/*************************************************************************/

	function place_popinarrow() {
		if (Foundation.MediaQuery.atLeast('xlarge')) {
			let left_pos = $("#popin_detail").offset().left;
			$(".wrap_arrow.to_right").css({"left" : left_pos + $('#popin_detail').outerWidth()});
			$(".wrap_arrow.to_left").css({"left": left_pos});
		}
	}

	$(document).bind('_js_ready', function() {
		$('#popin_detail').on('open.zf.reveal',function(){
			place_popinarrow();

			$(window).on('resize',function(){
				place_popinarrow();
			});

			$("body").addClass("overflow");

			// Init foundation components in popin
			$('.wrap_arrow').removeClass('is-hidden');
			$('#popin_detail #form_postuler, #popin_detail #col_right_popin, #popin_detail #commentaires_form_popin, #popin_detail #comment-list_popin').foundation();

			//On opening right col
			$('#col_right_popin').on('off.zf.toggler',function(){
				$('#btn_col_right_popin').addClass('open');
				$('.wrap_arrow, #popin_detail .close-button').addClass('hide');
				$('#main').addClass('zindex');
			});

			// On closing right col
			$('#col_right_popin').on('on.zf.toggler',function(){
				$('#btn_col_right_popin').removeClass('open');
				$('.wrap_arrow, #popin_detail .close-button').removeClass('hide');
				$('#main').removeClass('zindex');
			});

			// Init slick slider
			/*$('#popin_detail #slider_page_popin .slick_bandeau').slick({
				dots: true,
				arrows: false,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				autoplay: true,
				fade: true,
				adaptiveHeight: true
			});*/
		});

		$('#popin_detail').on('closed.zf.reveal',function(){
			// Fix disparition fleche popin detail fermeture popin diaporama
			if ($(this).attr('aria-hidden') == 'true') {
				$("body").removeClass("overflow");
				$('.wrap_arrow').addClass('is-hidden');
			}
		});

		// On opening right col
		let openColRight = function() {
		let inColRight = false;

			$('#col_right').on('off.zf.toggler',function(){
				$('#col_right').scrollTop(0);
				$('#cont_btn_col_right').addClass('open');
				$('#btn_col_right').text("Cacher les infos pratiques");
				$('#main').addClass('zindex');
				$("body").addClass("overflow");

				$('#col_right, #col_right_inner').addClass('mui-enter-active');
				animate();
				setTimeout(function(){ animate();},300);

				if ((Foundation.MediaQuery.current == "medium") || (Foundation.MediaQuery.current == "small")){
					$("#cont_btn_col_right, #cont_btn_col_right_popin").addClass("open");
				}
			});
		}
		openColRight();

		// On closing right col
		$('#col_right, #col_right_popin').on('on.zf.toggler',function(){
			$('#cont_btn_col_right, #cont_btn_col_right_popin').removeClass('open');
			$('#btn_col_right, #btn_col_right_popin').text("Voir les infos pratiques");
			$('#main').removeClass('zindex');
			$("body").removeClass("overflow");
			// $('#col_right, #col_right_popin').addClass('mui-enter-active');
				// animate();

			if ((Foundation.MediaQuery.current == "medium") || (Foundation.MediaQuery.current == "small")){
				$("#cont_btn_col_right, #cont_btn_col_right_popin").removeClass("open");
			}
		});
	});

	$(document).bind('_js_ready', function() {

		$('.popin_detail').on('open.zf.reveal',function(){

			let html_offset = Math.abs(parseInt($("html").css('top')));

			$('.popin_detail .image_pop').on('open.zf.reveal',function(){
				let popin_detail_offset = Math.abs($(".popin_detail").offset().top);
				let popin_detail_top = parseInt($(".popin_detail").css("top"));
				let top = popin_detail_offset + popin_detail_top;
				$("html").css({"top": html_offset});
				setTimeout(function(){
					$('.popin_detail').parent('.reveal-overlay').animate( { scrollTop: top }, 0 );
				; }, 0);
			});
			$('.popin_detail .image_pop').on('closed.zf.reveal',function(){
				$("html").css({"top": html_offset});
			});
		});
	});

	// Refresh des slick slider à l'ouverture des éléments type popin
	// $('.reveal').on('open.zf.reveal',function(){ $('.slick-slider').slick('refresh'); });

	// PAGE TYPE CIMEOS
		function animate() {
			let observer_act_class = new Hunt(document.getElementsByClassName('act'), {
		      enter: function(el) {
		        el.classList.add('mui-enter-active');
		      },
		      leave: function(el) {
		        el.classList.remove('mui-enter');
		      },
		      persist: true,
		      throttleInterval: 100,
		    });

		    if ( ($('#page').not("#page.list").length) || ($('#home')))  {
				let observer_act_class_not_list = new Hunt(document.getElementsByClassName('mui-enter'), {
			      enter: function(el) {
			        el.classList.add('mui-enter-active');
			      },
			      leave: function(el) {
			        el.classList.remove('mui-enter');
			      },
			      persist: true,
			      throttleInterval: 100,
			    });
			}

		    let observer_active_title_class = new Hunt(document.getElementsByClassName('active-title'), {
		      enter: function(el) {
		        el.classList.add('mui-enter-active');
		      },
		      leave: function(el) {
		        el.classList.remove('mui-enter');
		      },
		      persist: true,
		      throttleInterval: 100,
		    });

		    let lazyImages = document.querySelectorAll('img.lazy');
		    let img_observer = new Hunt(lazyImages, {
			  enter: function(image) {
			  	image.src = image.dataset.src;
			  }
			});

			// lazy videos
			let lazyVideos = $('video.lazy');
		    let video_observer = new Hunt(lazyVideos, {
			  enter: function(video) {
				  let src = video.dataset.src;
				  let type = video.dataset.type;

				  if(!video.querySelector('source')) {
					let source = document.createElement("source");
					source.setAttribute("src", src);
					source.setAttribute("type", type);
					video.appendChild(source);
				  }
			  }
			});

			// lazy vidéo externe - external video
			let lazyExternal = $('.external_vid.lazy');
			let external_observer = new Hunt(lazyExternal, {
				enter: function(externalVid) {
					let $externalVid = $(externalVid);
					let $child = $externalVid.find('.element_to_remove');
					let $img = $externalVid.find('img');

					if(!$externalVid.hasClass('video_appeared')) {
						if ($externalVid.hasClass('youtube')) {
							// create div.youtube_player for tarteaucitron
							$('<div>')
								.addClass('youtube_player')
								.attr("title", $externalVid.find('.title_video').text())
								.attr("data-videoID", $img.attr('data-videoID'))
								.attr("data-width", $img.attr('data-width'))
								.attr("data-height", $img.attr('data-height'))
								.attr("data-theme", $img.attr('data-theme'))
								.attr("data-rel", $img.attr('data-rel'))
								.attr("data-controls", $img.attr('data-controls'))
								.attr("data-showinfo", $img.attr('data-showinfo'))
								.attr("data-autoplay", $img.attr('data-autoplay'))
								.attr("data-mute", $img.attr('data-mute'))
								.appendTo($externalVid);
							$child.remove();
							$externalVid.addClass('video_appeared');
						}
						if ($externalVid.hasClass('vimeo')) {

							// create div.youtube_player for tarteaucitron
							$('<div>')
								.addClass('vimeo_player')
								.attr("title", $externalVid.find('.title_video').text())
								.attr("data-videoID", $img.attr('data-videoID'))
								.attr("data-width", $img.attr('data-width'))
								.attr("data-height", $img.attr('data-height'))
								.appendTo($externalVid);
							$child.remove();
							$externalVid.addClass('video_appeared');
						}

						// if tarteaucitron is initialized, execute again the services
						if (tarteaucitron !== undefined) {
							tarteaucitron.job.forEach(function (e) {
								tarteaucitron.job.push(e)
							});
						}
					}
				}
			});

			// Lazy load video poster
			let lazyExternal_poster = $('.slick-slide.slick-current + .slick-slide .external_vid img');
			let external_observer_poster = new Hunt(lazyExternal_poster, {
				enter: function(externalVid_poster) {
					externalVid_poster.src = externalVid_poster.dataset.src;
				}
			});

		}

		$(document).bind('_js_load', function() {
			animate();
		});

		$(document).bind('_js_ready', function() {
			/* Content links */
			// Add act class on content links
			$("#content_page a, #content_page ul li, #content_page ol li, #content_page_popin a, #content_page_popin ul li, #content_page_popin ol li").addClass("act");

			if(( $("#page.list").length) || ( $("#page.carto_tpl").length)) {
				//$("#content_page > *, #content_page_popin > *").addClass("active-title fade-in mui-enter");
			} else {
				$("#content_page *, #content_page_popin *").addClass("active-title fade-in mui-enter");
			}
			animate();

			/*
			$("#content_page a.act.mui-enter-active, #content_page_popin a.act.mui-enter-active").on("mouseenter",function(){
				$(this).removeClass("mui-enter-active reinit");
				that = this;
				// Remove class after 3s
				setTimeout(function(){ $(that).addClass("mui-enter-active");},300);
				// return false;
			});
			*/
		});

		// Apparition des element au scroll dans la colonne de droite
			$("#col_right_inner").scroll(function() { animate(); });
	// [END] PAGE TYPE CIMEOS


/*************************************************************************/
/********************************* AUTRES ********************************/
/*************************************************************************/

	$(document).bind('_js_ready', function() {

		// CLOSE COOKIES
		$('#cookie_close').click(function(event) {
			$('#cookie_msg').hide();
			$('#cookie_msg').addClass("display_none");
		});

	});


/*************************************************************************/
/****************************** GESTION LOGIN ****************************/
/*************************************************************************/

	let params={};
	window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(str,key,value){params[key] = value;});
	$(document).bind('_js_ready', function() {
		if(params['tx_felogin_pi1%5Bforgot%5D']){
		  $('#popin_compte').foundation('open'); 
		}
		if(params['tx_felogin_pi1%5Bforgothash%5D']){
		  $('#popin_compte').foundation('open'); 
		}
		if(params['tx_felogin_pi1%5Bbtlf%5D']){
		  $('#popin_compte').foundation('open'); 
		}
		if($('#login_status p').text().indexOf('incorrect') > -1){
		  $('#popin_compte').foundation('open'); 
		}
	});


/*************************************************************************/
/******************************** POPIN FOCUS ****************************/
/*************************************************************************/

	$(document).bind('_js_ready', function() {
		$('.reveal').on('open.zf.reveal', function(){
			// console.log($(this));
			let $this = $(this);
			if(!$this.is(":visible")) {
				$this.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
					makeFocusable($this);
				});
			}else{
				makeFocusable($this);
			}
		});
	});

	let makeFocusable = function(element) {
		let id = element.attr("id");
		let elementsFocusable = $('#' + id + ' :focusable');
		if (elementsFocusable[0]) {
			elementsFocusable[0].focus();
		}
	};

/*************************************************************************/
/***************** GESTION DE L'ANCRE DANS LES FILTRES *******************/
/*************************************************************************/

	$(document).bind('_js_ready', function() {
		if($(location.href.split("#")[1]).selector == "line_tools_moteur") {
			let target = $('#'+location.href.split("#")[1]);
			if (target.length) {
				$('html,body').animate({
				scrollTop: target.offset().top - 10
				}, 0);
			}
		}
	});


/*************************************************************************/
/*************************** BANDEAU IE 11 *******************************/
/*************************************************************************/

	$(document).bind('_js_ready', function() {

		let ie11_message = '<div id="popin_navigateurs" class="reveal full open without-overlay" data-reveal data-animation-in="fade-in" data-animation-out="fade-out" aria-label="Fenêtre de navigateur obsolète"><div class="wrap grid-x grid-padding-x flex-dir-column align-center small-12"><p role="heading" aria-level="1">Votre navigateur est obsolète.</p><p>Nous vous recommandons de le remplacer.</p><h2>Télécharger des navigateurs plus récents</h2><ul class="grid-x grid-padding-x medium-up-3 small-up-1"><li class="cell"><div class="border_nav"><h3>Google Chrome</h3><div class="grid-x grid-padding-x align-center"><p class="cell"><a href="https://www.google.com/chrome/" target="_blank" title="Télécharger Google Chrome pour Windows (Nouvelle Fenêtre)">Windows </a></p></div></div></li><li class="cell"><div class="border_nav"><h3>Mozilla Firefox</h3><div class="grid-x grid-padding-x align-center"><p class="cell"><a href="https://www.mozilla.org/fr-FR/firefox/new/" target="_blank" title="Télécharger Mozilla Firefox pour Windows (Nouvelle Fenêtre)">Windows </a></p></div></div></li><li class="cell" ><div class="border_nav"><h3>Opera</h3><div class="grid-x grid-padding-x small-up-1"><p class="cell"><a href="https://www.opera.com/fr/download" target="_blank" title="Télécharger Opera pour Windows (Nouvelle Fenêtre)">Windows </a></p><p class="cell"><a href="https://m.opera.com/" target="_blank" title="Télécharger Opera pour Window Phone (Nouvelle Fenêtre)">Téléphone </a></p></div></div></li></ul></div></div>';

		let edgeLink = '<h2>Ouvrir la page avec Microsoft Edge</h2><div class="grid-x grid-padding-x medium-up-3 small-up-1"><div class="cell"><div class="border_nav"><h3 class="title_edge">Microsoft Edge</h3><div class="align-center"><button aria-label="Ouvrir la page avec Microsoft Edge">Windows </button></div></div></div></div>';

		function GetIEVersion() {
			let sAgent = window.navigator.userAgent;
			let Idx = sAgent.indexOf("MSIE");

			// If IE, return version number.
			if (Idx > 0)
				return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

			// If IE 11 then look for Updated user agent string.
			else if (!!navigator.userAgent.match(/Trident\/7\./))
				return 11;

			else
				return 0; // It is not IE
		}

		if (GetIEVersion() > 0)  {

			$("body").prepend(ie11_message);
			$('body').css("overflow","hidden");

			// identifiant.foundation pour init
			$('#popin_navigateurs').foundation();

			// si l'utilisateur est sous windows 10
			if(window.navigator.userAgent.match(/Windows NT 10.0/)) {
				// afficher l'option pour ouvrir avec edge
				$('#popin_navigateurs .wrap').append(edgeLink);

				// ouvrir avec edge
				$('.bloc_compat button').click(function() {
					window.open("microsoft-edge:"+ document.location.href);
				});
			}
		}
	});

/*************************************************************************/
/*************************** ACCESSIBILY ARIA ****************************/
/*************************************************************************/

	/*** PAGE DE LISTE : PERTE FOCUS POPIN DETAIL  ***/
	/*** Fermeture popin + apres clic suiv - prev ***/

		let get_list_item_focus = function() { focusing(); }
		let item_focused = [];
		let pop = true;

		let clic_arrow = function() {
		  $('.to_left .arrows').on('click',function(){
		      pop = false;
		      let item_initial = item_focused.toString();
		      item_focused.pop();
		      let item_prev = $(".list_item[data-uid = '" + item_initial +"']").prev().attr("data-uid");
		      item_focused.push(item_prev);
		  });

		  $('.to_right .arrows').on('click',function(){
		      pop = false;
		      let item_initial = item_focused.toString();
		      item_focused.pop();
		      let item_next = $(".list_item[data-uid = '" + item_initial +"']").next().attr("data-uid");
		      item_focused.push(item_next);
		  });
		}

		let close = function() {
		  $('#popin_detail').on('closed.zf.reveal',function(){
		      pop = true;
		      let item = item_focused;
		      $(".list_item[data-uid = '" + item +"'] .titre a").focus();
		  });
		}

		let popfunction = function() {
		  clic_arrow();

		  $('#popin_detail').on('closeme.zf.reveal',function(){
		      if (pop == true) {
		          item_focused.pop();
		          let item = $(".list_item.focusing").attr("data-uid");
		          item_focused.push(item);
		      }
		  });
		}

		function reinit_list_item_focus() {
		  popfunction();
		  close();
		}

		$(document).bind('_js_ready', function() {
	       // Page de liste : perte focus fermeture popin_detail
			//get_list_item_focus();
			//reinit_list_item_focus();
	    });

	/*** MENU PRINCIPAL : li avec sous menu  ***/
		$(document).bind('_js_ready', function() {

			// Version popin : bouton au N2 pour ouvrir N3
		    $("#menu_principal .level2.has-submenu-toggle a span").each(function(index){
		        let initial_intitule = $(this).parent("a").parent(".level2.has-submenu-toggle").children('button').children("span").text();
		        let new_intitule = initial_intitule + " " + $(this).text();
		        // Modif title + span
		        $(this).parent("a").parent(".level2.has-submenu-toggle").children('button').attr("title", new_intitule).children("span").text(new_intitule);
		        $(this).parent("a").parent(".level2.has-submenu-toggle")
		    });

		    // Version horizontale
		    /*$("#menu_principal > ul > li").removeAttr("aria-expanded");
			$("#menu_principal > ul > li > a").each(function(index){
				let initial_intitule = $(this).parent("li.has-submenu-toggle").children('button').text();
				let new_intitule = initial_intitule + " " + $(this).text();
				// Modif title + span
				$(this).parent("li.has-submenu-toggle").children('button').attr("title", new_intitule).children("span").text(new_intitule);
			});
			$('#menu_principal').on('up.zf.accordionMenu','down.zf.accordionMenu',function(){
			  $("#menu_principal > ul > li").removeAttr("aria-expanded");
			});
			$('#menu_principal').on('down.zf.accordionMenu',function(){
			  $("#menu_principal > ul > li > ul[aria-hidden='false']").parent("li").addClass("aria-expanded");
			});
			$('#menu_principal').on('up.zf.accordionMenu',function(){
			  $("#menu_principal > ul > li > ul[aria-hidden='false']").parent("li").removeClass("aria-expanded");
			});
			$("#btn_close_horizontal_menu, #overlay_menu").on("click", function(){
			  $("#menu_principal > ul > li").removeAttr("aria-expanded");
			  $("#menu_principal > ul > li > button[aria-expanded='true']").attr("aria-expanded", "false");
			  $("#menu_principal > ul > li > ul[aria-hidden='false']").parent("li").removeClass("aria-expanded");
			});*/
		});

/*************************************************************************/
/************************* POWERMAIL VALIDATION **************************/
/*************************************************************************/

	// $(document).bind('_js_ready', function() {
		// /**
		 // * Add accessibility attributes on invalid field
		 // *
		 // * @since 1.5.0.9
		 // */
		// window.Parsley.on('field:error', function() {
			// this.$element.attr( 'aria-describedby', this._ui.errorsWrapperId ).attr( 'aria-invalid', 'true' );
			// this._ui.$errorsWrapper.attr( 'aria-live', 'polite' );
		// });
//
		// /**
		 // * If field is valid and was marked invalid, remove aria.invalid
		 // *
		 // * @since 1.5.0.9
		 // */
		// window.Parsley.on( 'field:success', function () {
			// if( this.$element.attr( 'aria-invalid' ) ){
				// this.$element.removeAttr( 'aria-invalid' );
			// }
		// });
	// });

/*************************************************************************/
/****************************** LOYDE BENZ *******************************/
/*************************************************************************/

	$(document).ready(function(){
		$(document).trigger('_js_ready');
		$(document).trigger('_page_ready');
		$(document).trigger('_page_ready_geo');
	});

	$(window).on('load',function(){
		$(document).trigger('_js_load');
		$(document).trigger('_social_stream_ready');
	});
